import * as constants from './constants';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';
import reducer from './reducer';
import IncidentsGrid from './components/IncidentsGrid';
import IncidentDetails from './components/IncidentDetails';

export default {
    constants, reducer, actions, actionTypes, selectors,
    IncidentsGrid, IncidentDetails
}